
<template>
  <div class="pop-up-container">
    <DxPopup
      :visible="isVisible"
      title="Bank Fee Settings"
      :height="250"
      width="40%"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      :hide-on-outside-click="false"
      @shown="updateSettings()"
      @hidden="cancelBankFeeEdit()"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="125"
          :isNormal="true"
          :data-model="newBankFeeSettings"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          :ref="'bank-fee'"
        ></gc-form>
      </div>

      <div class="footer-buttons">
        <DxButton
          text="Save"
          type="default"
          styling-mode="contained"
          class="button-full-width margin-left-5"
          @click="saveBankFeeEdit()"
          :disabled="bankFeeSettingsAreNotValid"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="button-full-width margin-right-5"
          @click="cancelBankFeeEdit()"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: function () {},
    },
    bankFeeSettings: {
      type: Object,
      default: undefined,
    },
    setLoading: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      newBankFeeSettings: {
        GLAccount: undefined,
        Branch: undefined,
        Division: undefined,
        Comment: "",
        // Key: undefined,
      },
    };
  },
  created() {
    document.addEventListener("keydown", this.escHandler);
  },
  destroyed() {
    document.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    escHandler(e) {
      setTimeout(() => {
        if (e.code == "Escape") {
          this.cancelBankFeeEdit();
        }
      }, 100);
    },
    updateSettings() {
      this.setLoading(true);
      this.newBankFeeSettings.GLAccount = this.bankFeeSettings.GLAccount;
      this.newBankFeeSettings.Branch = this.bankFeeSettings.Branch;
      this.newBankFeeSettings.Division = this.bankFeeSettings.Division;
      this.newBankFeeSettings.Comment = this.bankFeeSettings.Comment;

      if (this.bankFeeSettings.Key != undefined)
        this.newBankFeeSettings.Key = this.bankFeeSettings.Key;
      this.setLoading(false);
    },
    cancelBankFeeEdit() {
      this.callback(true);
    },
    saveBankFeeEdit() {
      this.callback(false, { ...this.newBankFeeSettings });
    },
  },
  computed: {
    bankFeeSettingsAreNotValid() {
      for (const value of Object.values(this.newBankFeeSettings)) {
        if (value == undefined) return true;
      }
      return false;
    },
    isVisible() {
      return this.visible;
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "GLChart",
                  dataField: "GLAccount",
                  label: {
                    text: "Account",
                  },
                  required: true,
                },
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  label: {
                    text: "Branch",
                  },
                  required: true,
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  label: {
                    text: "Division",
                  },
                  required: true,
                },
                {
                  screenField: "Comment",
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.footer-buttons {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 0.2em;
}

.button-full-width {
  width: 100%;
}

.margin-right-5 {
  margin-right: 10px;
}

.margin-left-5 {
  margin-left: 10px;
}
</style>